import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vetDocStatus',
  standalone: true
})
export class VetDocStatusPipe implements PipeTransform {
  transform(status: string | null): string {
    if (!status) return '-';
    return status === 'YES' ? 'Есть' : 'Нет';
  }
}
